import { decode } from '@atc/bonnet-seo';
import { fetchSeoLocation } from '../fetchers';
import { dealerlistQuery, kbbBrand } from '../constants';
import { getPath, transformsMake, filterDealerQuery } from '../utilities';
import getValidLocationsFromSiteMap from '../utilities/getValidLocationsFromSiteMap';

// Converts seo-location-service values like "San+Jose+CA-95101" to sitemap keys like "san-jose-ca".
// Input format from getCities: "{city words joined by +}+{STATE}-{zip}".
const toLocationKey = (value) => value.replace(/-\d+$/, '').replace(/\+/g, '-').toLowerCase();

export default function getSeoLocations() {
    return async (ctx) => {

        let locations = await fetchSeoLocation({
            query: {
                state: ctx.query.state,
            },
        });

        const isKbb = (ctx.data.brand === kbbBrand);
        const validLocationsFromSiteMap = await getValidLocationsFromSiteMap(isKbb);
        const validLocations = new Set(
            Array.isArray(validLocationsFromSiteMap)
                ? validLocationsFromSiteMap
                    .map((location) => {
                        if (typeof location === 'string') {
                            return location;
                        }

                        if (location && typeof location === 'object' && typeof location.value === 'string') {
                            return toLocationKey(location.value);
                        }

                        return null;
                    })
                    .filter(Boolean)
                : []
        );

        // fetchSeoLocation's circuit breaker falls back to {} when the service times out
        if (validLocations.size !== 0 && Array.isArray(locations)) {
            locations = locations.filter((location) => validLocations.has(toLocationKey(location.value)));
        } else {
            locations = [];
        }

        const data = await Promise.all(locations.map(async ({ value, label }) => {
            const location = await decode(value, { param: 'location' });

            // remove unwanted parameters from the existing query string
            // eslint-disable-next-line no-unused-vars
            const { numRecords, firstRecord, sortBy, makeCode, dma, searchRadius, location: queryLocation, make, ...query } = ctx.query;
            const seoMakeCode = transformsMake(make?.toLowerCase(), true) ?? '';

            // Build a query object for the new url
            const _query = {
                ...query,
                ...location,
                seoMakeCode,
            };

            delete _query.make;
            delete _query.zip;

            const href = await getPath(ctx.pageName, filterDealerQuery(_query, dealerlistQuery), { brand: ctx.data.brand });
            return {
                href,
                label: label.replace(/\+/g, ' '),
            };
        }));

        // update the context data object with the response
        Object.assign(ctx.data, { seoLocations: data });
    };
}
